import { Plus, Trash2 } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { formatEUR } from "../lib/format";

export const DEFAULT_SERVICES = [
  {
    id: "fixed-commercial",
    description: "Commercial services and custom itinerary design in destination. 9 Specialists",
    amount: 18000,
    enabled: true,
  },
  {
    id: "fixed-247",
    description: "24/7 customer support services in destination: Spain, Portugal, Italy, and Morocco",
    amount: 12000,
    enabled: true,
  },
  {
    id: "fixed-tracking",
    description: "Tracking and sales software services",
    amount: 2500,
    enabled: true,
  },
];

/**
 * Editable list of fixed services with per-line toggle (include in invoice).
 * Each service: { id, description, amount, enabled }
 */
export default function ServicesEditor({ services, setServices }) {
  const updateService = (idx, field, value) => {
    const arr = [...services];
    arr[idx] = { ...arr[idx], [field]: value };
    setServices(arr);
  };

  const addService = () => {
    setServices([
      ...services,
      {
        id: `svc-${Date.now()}`,
        description: "",
        amount: 0,
        enabled: true,
      },
    ]);
  };

  const removeService = (idx) => {
    setServices(services.filter((_, i) => i !== idx));
  };

  const enabledTotal = services
    .filter((s) => s.enabled)
    .reduce((a, s) => a + Number(s.amount || 0), 0);

  return (
    <div>
      <div className="space-y-2">
        {services.map((s, i) => (
          <div
            key={s.id}
            className={`flex items-center gap-2 px-3 py-2 rounded-md border ${
              s.enabled ? "border-slate-200 bg-white" : "border-slate-100 bg-slate-50 opacity-60"
            }`}
            data-testid={`service-row-${i}`}
          >
            <button
              type="button"
              role="switch"
              aria-checked={s.enabled}
              onClick={() => updateService(i, "enabled", !s.enabled)}
              className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors flex-shrink-0 ${
                s.enabled ? "bg-slate-900" : "bg-slate-300"
              }`}
              data-testid={`service-toggle-${i}`}
              title={s.enabled ? "Incluido en la factura" : "Excluido"}
            >
              <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${s.enabled ? "translate-x-4" : "translate-x-1"}`} />
            </button>
            <Input
              value={s.description}
              onChange={(e) => updateService(i, "description", e.target.value)}
              className="flex-1 h-9 text-sm"
              placeholder="Concepto del servicio"
              disabled={!s.enabled}
              data-testid={`service-desc-${i}`}
            />
            <Input
              type="number"
              step="0.01"
              value={s.amount}
              onChange={(e) => updateService(i, "amount", Number(e.target.value))}
              className="w-32 h-9 text-right font-mono text-sm"
              disabled={!s.enabled}
              data-testid={`service-amount-${i}`}
            />
            <Button
              size="icon"
              variant="ghost"
              onClick={() => removeService(i)}
              data-testid={`service-remove-${i}`}
            >
              <Trash2 size={14} className="text-rose-600" />
            </Button>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between mt-3 pt-3 border-t border-slate-100">
        <Button size="sm" variant="outline" onClick={addService} data-testid="add-service-btn">
          <Plus size={14} className="mr-1" /> Añadir servicio
        </Button>
        <div className="text-xs text-slate-600">
          Total servicios activos:{" "}
          <span className="font-mono font-semibold text-slate-900">{formatEUR(enabledTotal)}</span>
        </div>
      </div>
    </div>
  );
}
